import { render } from "./UserLogoutButton.vue?vue&type=template&id=55ce0235&scoped=true"
import script from "./UserLogoutButton.vue?vue&type=script&lang=js"
export * from "./UserLogoutButton.vue?vue&type=script&lang=js"

import "./UserLogoutButton.vue?vue&type=style&index=0&id=55ce0235&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ce0235"]])

export default __exports__